import { Routes } from '@angular/router';

import { AuthenticationGuard } from './guards/authentication.guard';
import { CheckoutPayGuard } from './guards/checkout-pay.guard';
import { ContentResolver } from './guards/content.resolver';
import { HasSubscriptionGuard } from './guards/has-subscription.guard';
import { LocaleResolver } from './guards/locale.resolver';
import { ResultGuard } from './guards/result.guard';
import { CheckoutLoginComponent } from './pages/checkout-login/checkout-login.component';
import { CheckoutPayComponent } from './pages/checkout-pay/checkout-pay.component';
import { CheckoutThankYouComponent } from './pages/checkout-thank-you/checkout-thank-you.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { LoginComponent } from './pages/login/login.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { ResultComponent } from './pages/result/result.component';
import { SettingsComponent } from './pages/settings/settings.component';
import { TestIntroComponent } from './pages/test-intro/test-intro.component';
import { ShareResultComponent } from './pages/share-result/share-result.component';
import { InternationalTestComponent } from './pages/international-test/international-test.component';
import { UserManagementComponent } from './pages/user-management/user-management.component';
import { DataConsentRevokeComponent } from './components/data-consent-revoke/data-consent-revoke.component';

export const mainNavigationRoutes: Routes = [];

export const otherLocalizedRoutes: Routes = [
  // {
  //   path: 'register',
  //   component: RegisterComponent,
  //   resolve: { content: ContentResolver },
  //   data: {
  //     contentId: '6Y7AfBQ6BtTz4hNnp1nC4j',
  //   },
  // },
  {
    path: 'test',
    data: {
      theme: 'always-hamburger',
    },
    loadChildren: () =>
      import('./views/calculator-view/calculator-view.module').then(
        (m) => m.CalculatorViewModule,
      ),
  },
  {
    path: 'login',
    component: LoginComponent,
    resolve: { content: ContentResolver },
    data: {
      navigationLabel: {
        'en-US': 'Login',
        fi: 'Kirjaudu',
      },
      contentId: '6UlAGBVHR9vAECPUa9Hz8J',
    },
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
    resolve: { content: ContentResolver },
    data: {
      contentId: '6y9Ct5jDZFeIoOJ4d1pOm4',
    },
  },
  {
    path: 'profile',
    component: ProfileComponent,
    resolve: { content: ContentResolver },
    data: {
      theme: 'fixed-white',
      navigationLabel: {
        'en-US': 'Profile',
        fi: 'Profiili',
      },
      contentId: '1PImDPrV4xPKJYgPHRQXJE',
    },
    canActivate: [AuthenticationGuard],
  },
  {
    path: 'consent-revoke',
    component: DataConsentRevokeComponent,
    resolve: { content: ContentResolver },
    data: {
      theme: 'standard',
    },
  },
  {
    path: 'result',
    component: ResultComponent,
    resolve: { content: ContentResolver },
    data: {
      theme: 'always-hamburger-with-white-logo',
      contentId: 'QkmzyhMs7OZrY0vQpXzdA',
    },
    canActivate: [ResultGuard],
  },
  {
    path: 'share-result',
    component: ShareResultComponent,
    resolve: { content: ContentResolver },
    data: {
      theme: 'fixed-white',
      contentId: '1f20pVuMYCGaZse4G9Von0',
    },
  },
  {
    path: 'checkout/login',
    component: CheckoutLoginComponent,
    resolve: { content: ContentResolver },
    data: {
      theme: 'always-hamburger-with-white-logo-in-desktop',
      contentId: '71jRD2fbbhgfFUjpNusSx4',
    },
    canActivate: [ResultGuard],
  },
  // {
  //   path: 'checkout/join',
  //   component: CheckoutJoinComponent,
  //   resolve: { content: ContentResolver },
  //   data: {
  //     theme: 'always-hamburger-with-white-logo-in-desktop',
  //     contentId: '3FeoowjEwmbxT1IEX5fFv3',
  //   },
  //   canActivate: [ResultGuard],
  // },
  {
    path: 'checkout/pay',
    component: CheckoutPayComponent,
    resolve: { content: ContentResolver },
    data: {
      theme: 'always-hamburger-with-white-logo-in-desktop',
      contentId: '2YQkNMJANN8a2Yro7f632F',
    },
    canActivate: [CheckoutPayGuard, HasSubscriptionGuard],
  },
  {
    path: 'checkout/thank-you',
    component: CheckoutThankYouComponent,
  },
  {
    path: 'settings',
    component: SettingsComponent,
    resolve: { content: ContentResolver },
    data: {
      contentId: '4XXSqbEQYeAktkwXfa22zz',
      navigationLabel: {
        'en-US': 'Settings',
        fi: 'Asetukset',
      },
    },
    canActivate: [AuthenticationGuard],
  },
  {
    path: 'start-test',
    component: TestIntroComponent,
    resolve: { content: ContentResolver },
    data: {
      theme: 'always-hamburger',
      contentId: '2L2GnCjadyoGeZMwfsZWVL',
    },
  },
  {
    path: 'international-test',
    component: InternationalTestComponent,
    resolve: { content: ContentResolver },
    data: {
      theme: 'always-hamburger',
      contentId: '4omha1DnTQiQplDvEQ2QNy',
    },
  },
];

export const englishOnlyRoutes: Routes = [
  {
    path: 'user-management',
    component: UserManagementComponent,
    resolve: { content: ContentResolver },
    data: {
      contentId: '5U57J8ecfID4iMKTTODXmv',
    },
  },
];

export const routes: Routes = [
  {
    path: 'fi',
    data: { locale: 'fi' },
    resolve: { locale: LocaleResolver },
    children: [...otherLocalizedRoutes],
  },
  {
    path: '',
    data: { locale: 'en-US' },
    resolve: { locale: LocaleResolver },
    children: [...otherLocalizedRoutes, ...englishOnlyRoutes],
  },
];

export const routesRoot: Routes = [
  {
    path: '',
    runGuardsAndResolvers: 'always',
    children: routes,
  },
];
